<template>

  <section class="content">

  <modal title="Clôturer  une tournée"
             v-on:close="doCloseAnyModals"
             v-if="closeModal === true">
        <tournees-close slot="body"
                         v-on:close="doCloseAnyModals"
                         :tournee="tournee"></tournees-close>
      </modal>

    <tournees-list
         v-on:close="clickClose">
    </tournees-list>

  </section>

</template>

<script>
import TourneesList from './TourneesList'
import TourneesClose from './TourneesClose'
import Modal from '../commons/Modal'

export default {
  components: {
    TourneesList,
    TourneesClose,
    Modal,
  },
  data: function () {
    return {
      closeModal: false,
      tournee: null,
    }
  },
  methods: {
    doCloseAnyModals: function () {
      this.closeModal = false
    },
    clickClose(tournee) {
    this.tournee = tournee
      this.closeModal = true
    },

  },
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// Tournees.vue?2cddcc85